const path:string = "package/longhudou/sound/"
import AudioManager from "../../../manager/audio_manager";
const { ccclass, property } = cc._decorator;
@ccclass
export default class LongHuDouTableSound{
    WinByResuleType = ["he", "long_win", "hu_win"]
    WinByResuleAminType = [null, "longying_amin", "huying_amin"]
    //播放点数
    playDianShu(dianshu:number, callback:Function = null){
        let name = dianshu + "_dian"
        this.playSound(path + name, name, callback)
    }

    playBtn(){
        let name = "button"
        this.playSound(path + name, name)
    }

    playNumber(){
        let name = "number"
        this.playSound(path + name, name)
    }

    //1 龙 2虎 
    playPaiName(typePai:number, callback:Function){
        let name = typePai == 1 ? "fp_long" : "fp_hu"
        this.playSound(path + name, name, callback)
    }


    //播放结果
    playerWin(winType){
        let name = this.WinByResuleType[winType]
        if (name == null) { return }
        this.playSound(path + name, name)
    }

    //播放结果
    playerWinAmin(winType){
        let name = this.WinByResuleAminType[winType]
        if (name == null) { return }
        this.playSound(path + name, name)
    }

    //播放开始下注 和结束下注 isStart 为开始下注
    playStartOrBetBet(isStart){
        let name = isStart ? "start_bet" : "stop_bet"
        this.playSound(path + name, name)
    }

    //播放时间声音
    playTimeSound(){
        let name = "daojishi"
        this.playSound(path + name, name)
    }

    //叮叮的响声 -.-!
    playerDingDing(callback){
        let name = "dingding"
        this.playSound(path + name, name, callback)
    }

    //播放押注
    playBet(isBet:Boolean){
        let name = isBet ? "xiazhu" : "shouzhu"
        this.playSound(path + name, name)
    }

    //播放押注
    playFanPai(){
        let name = "fanpai"
        this.playSound(path + name, name)
    }

    playStartGame(){
        let name = "start_game"
        this.playSound(path + name, name)  
    }


    playSound(fullPath:string, soundName: string, callback:Function = null){
        AudioManager.instance.playSound(fullPath, false, callback)
    }

    playMusic(fullPath: string, soundName: string){
        AudioManager.instance.playMusic(fullPath, false)
    }

    playBgm(){
        this.playMusic(path + "bgm/long_hu", "long_hu")
    }

    stopBgm(){
        AudioManager.instance.stopAllMusic()
    }
}